import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=485a166a&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&id=485a166a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a166a",
  null
  
)

component.options.__file = "InvoiceList.vue"
export default component.exports